import styled from '@mui/material/styles/styled'

const MultiItem = styled('li')({
  margin: 0,
  padding: '0.375rem 0.75rem',
  marginRight: '0.5rem',
  marginBottom: '0.5rem',
  width: 'fit-content',
  display: 'inline-block',
  background: '#FAFAFA',
  border: '1px solid #F0F0F0',
  borderRadius: '4px',
})

export default MultiItem
